import React from "react";

import RewardTierIcon from "../../icons/rewardTierIcon.component";
import useContestSettings from "../../../hooks/useContestSettings";

import { StyledWrapper } from "./rewardTiers.style";

const RewardTiers = () => {
  const {
    data: { rewardPolicy, rewardTiers, rewardTierNotes },
  } = useContestSettings();
  const tierLabels = ["first", "second", "third"];
  const visible = rewardPolicy != "none" && rewardTiers.length > 0;

  return (
    <StyledWrapper className={`row p-0${visible ? "" : " d-none"}`}>
      <div className="col-12">
        <div
          id="RewardTiers"
          className="contest-heading mb-3 mt-5"
          data-anchor="Reward Tiers"
        >
          Reward Tiers
        </div>
        {rewardTierNotes && (
          <div className="reward-tier-panel-notes col-12 mb-4 p-0">
            {rewardTierNotes}
          </div>
        )}
        <div className="row ms-sm-0">
          {rewardTiers.map((tier, index) => (
            <div className="col-12 col-sm-4 mb-3 mb-sm-0 px-sm-0" key={index}>
              <div className="reward-tier-panel-item d-flex align-items-center mx-sm-0">
                <div className="reward-tier-panel-icon me-2 p-2 background-white rounded-circle float-start">
                  <RewardTierIcon size={44} tier={tierLabels[index]} />
                </div>
                <div className="reward-tier-panel-text">
                  {rewardPolicy.startsWith("percentile")
                    ? `${tier.name}`
                    : tier.number
                      ? `${tier.number} ${tier.name}`
                      : "Prize pool"}
                  {rewardPolicy.startsWith("percentile")
                    ? " share"
                    : tier.number === 1
                      ? " receives"
                      : tier.number > 1 && " receive"}
                  <br />
                  <span className="reward-tier-panel-amount">
                    {tier.amount}
                  </span>
                  {!rewardPolicy.startsWith("percentile") &&
                    tier.number > 1 &&
                    " each"}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </StyledWrapper>
  );
};

export default RewardTiers;
